<template>
  <div>
    <SubSideMenu
      :subsection="'Administration'"
      :options="options"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import SubSideMenu from "@/components/SideMenu/SubSideMenu/SubSideMenu.vue"

export default {
  name: "AdministrationSidebar",
  components: {
    SubSideMenu
  },
  computed: {
    ...mapGetters(["administrationNav", "getIsTenantSuperuser", "getIsAdmin"]),
    options() {
      return this.administrationNav.filter(item => {
        if (item.superOnly && !this.getIsTenantSuperuser) return false
        if (item.adminOnly && !this.getIsAdmin && !this.getIsTenantSuperuser) return false
        return true
      })
    }
  }
}
</script>
